import constant from '../../constant';
import request from '../../../utils/request';
import { GET_RECOMMAND_ARTICLES, GET_RECOMMAND_VIDEOS, GET_TRPC_RECOMMAND_ARTICLES, GET_INTEREST_RECOMMEND_ARTICLES } from '../../../urls'
import { appOriginHosts, getAppName, showTip } from '../../../utils'
import { query } from '../../../utils/yUtil';
import querystring from "query-string";
import { isTBS, isAndroid } from "../../../utils/UA";
import { APP_INFO } from "../../../utils/constant";
import TBSDownload from "../../../utils/tbs-download";

const transformationBottomTips = (data) => {
  const retData = data.map(item => {
    const {
      isGallery,
      title,
      docId,
      url,
      postTime,
      from
    } = item;

    const params = {
      ch: query('ch'),
      url,
      gallery: isGallery,
      cardmode: 1
    };

    const qbUrl = `${appOriginHosts.qb}/${docId}?${querystring.stringify(params)}`

    return {
      docId,
      url: qbUrl,
      title,
      postTime,
      from,
      image: item.picUrls.length > 0 ? item.picUrls[0] : '',
    };
  });
  return retData;
}
const getTRPCBottomTips = (recommList) => {
  let bottomTipsAry = []
  if (recommList && recommList instanceof Array && recommList.length > 0) {
    bottomTipsAry = recommList.length > 3 ? recommList.splice(0, 3) : recommList;
  }
  return bottomTipsAry
}

const getBottomTips = (recommList) => {
  let bottomTipsAry = []
  if (recommList && recommList instanceof Array && recommList.length > 0) {
    const hotAry = [];
    const relateAry = [];
    recommList.map(item => {
      if (item.fromType === 'hot') {
        hotAry.push(item);
      } else if (item.fromType === 'relate') {
        relateAry.push(item);
      }
      return null;
    });

    // ABB(一条相关两条热点)
    bottomTipsAry = (relateAry.length > 0 ? relateAry.splice(0, 1) : [])
      .concat(hotAry.length > 2 ? hotAry.splice(0, 2) : hotAry.splice(0, hotAry.length));

    let tempAry = [];
    if (relateAry.length > 3) {
      tempAry = relateAry.splice(2, 2);
    } else if (relateAry.length > 2) {
      tempAry = relateAry.splice(2, 1);
    }
    bottomTipsAry = bottomTipsAry.concat(tempAry);
    bottomTipsAry = bottomTipsAry.length > 3 ? bottomTipsAry.splice(0, 3) : bottomTipsAry.splice(0, bottomTipsAry.length);
  }
  return bottomTipsAry
}

const getArticles = (params = {}, callback) => {
  return async (dispatch) => {
    try {
      const sDocId = params.sDocId
      if (sDocId) {
        const { url, ch, guid } = params

        const res = await request.get(GET_RECOMMAND_ARTICLES, {
          docId: sDocId,
          guid,
          channel: ch,
          url,
          page: 1,
          count: 200
        })
        if (res.code === 0) {
          const { cardContents = [], list = [] } = res.data
          const recommandArticles = {
            cardContents,
            list
          }

          let docIdArr = []

          list.forEach(item => {
            docIdArr.push(item.docId)
          })

          cardContents.forEach(card => {
            const articles = card.articles || []
            articles.forEach(article => {
              docIdArr.push(article.docId)
            })
          })
          callback && callback(docIdArr || [])
          const bottomTips = getTRPCBottomTips(list);
          const bannerList = transformationBottomTips(bottomTips);
          dispatch(getArticlesSuccess({ recommandArticles, bannerList }))
        }
      } else {
        showTip('缺少必要参数 sDocId')
      }

    } catch (error) {
      console.log('getRecommandArticles error', error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}


const getArticlesSuccess = ({ recommandArticles, bannerList }) => {
  return {
    type: constant.RECOMMEND.GET_ARTICLES_SUCCESS,
    articles: recommandArticles,
    bannerList
  }
}

const getTRPCRecommand = (params = {}, callback) => {
  return async (dispatch) => {
    try {
      const sDocId = params.sDocId
      if (sDocId) {
        const { url, ch, guid, count } = params
        const res = await request.get(GET_TRPC_RECOMMAND_ARTICLES, {
          docId: sDocId,
          guid,
          channel: ch,
          url,
          page: 1,
          count: count || 200
        })
        if (res.code === 0) {
          const { cardContents = [], list = [] } = res.data
          const recommandArticles = {
            cardContents,
            list
          }
          callback && callback([])
          const bottomTips = getBottomTips(list);
          const bannerList = transformationBottomTips(bottomTips);
          dispatch(getArticlesSuccess({ recommandArticles, bannerList }));

          if (getAppName() === 'qb') {
            // 获取剪贴板
            let docIdArr = []
            list.forEach(item => {
              docIdArr.push(item.docId)
            })
            cardContents.forEach(card => {
              const articles = card.articles || []
              articles.forEach(article => {
                docIdArr.push(article.docId)
              })
            })
            const appInfo = APP_INFO['qb']
            const tbsDownload = new TBSDownload(window.tbs, appInfo.downloadUrl, appInfo.pkgName, '')
            getAppName() === 'qb' && window.ClipperForRMP && window.ClipperForRMP.initRmpNew({
              event: 2,
              type: 1,
              data: docIdArr.map(iter => { return { docId: iter } }),
              qbinstall: (isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && tbsDownload.isInstalled()) ? 1 : 0,
              env: window.location.host.indexOf('.sparta.html5.qq.com') > -1 ? 'test' : (window.location.host.indexOf('graykandianshare.html5.qq.com') > -1 ? 'gray' : 'pro') // 测试环境调用rmp的测试接口
            })
          }
        }
      } else {
        showTip('缺少必要参数 sDocId')
      }

    } catch (error) {
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}

const loadMoreArticles = () => {
  return {
    type: constant.RECOMMEND.LOAD_MORE_ARTICLES,
    articles: (articles) => {

      const page = articles.page + 1

      if (page > 1) {
        let { list, show, hasMore } = articles;

        const temp = list.slice((page - 1) * 10, (page - 1) * 10 + 10);

        show = show.concat(temp);


        if (temp.length < 10) {
          hasMore = false
        }

        return {
          ...articles,
          list,
          show,
          hasMore,
          page
        }
      }
    },
  }
}

const getBackNews = (params = {}) => {
  return async (dispatch) => {
    try {
      const { url, ch, guid, sDocId, _mediaType } = params

      const mediaType = _mediaType || query('mediaType')

      const res = await request.get(mediaType === 'video' ? GET_RECOMMAND_VIDEOS : GET_RECOMMAND_ARTICLES, {
        guid,
        channel: ch,
        url,
        page: 1,
        count: 200,
        targetApp: 'backNews',
        docId: sDocId || query('docId')
      })

      if (res.code === 0) {
        const { cardContents = [] } = res.data

        const backNewsCard = cardContents[0]

        if (!backNewsCard) {
          return dispatch(getBackNewsSuccess([]))
        }

        const medias = mediaType === 'video' ? backNewsCard.videos : backNewsCard.articles

        dispatch(getBackNewsSuccess({
          medias,
          mediaType: mediaType === 'video' ? 'video' : 'news'
        }))
      }

    } catch (error) {
      console.log('getRecommandArticles error', error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}

const getBackNewsSuccess = (backNews) => {
  return {
    type: constant.RECOMMEND.GET_BACK_NEWS_SUCCESS,
    backNews
  }
}

const getInterestRecommend = (params = {}, callback) => {
  return async (dispatch) => {
    try {
      const sDocId = params.sDocId
      if (sDocId) {
        const res = await request.get(GET_INTEREST_RECOMMEND_ARTICLES, { docId: sDocId })
        if (res.code === 0) {
          dispatch({
            type: constant.RECOMMEND.GET_INTEREST_RECOMMEND_SUCCESS,
            interestRecommend: res.data,
          });
          callback && callback([])
        }
      } else {
        showTip('缺少必要参数 sDocId')
      }
    } catch (error) {
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}

export default {
  getArticlesSuccess,
  getArticles,
  loadMoreArticles,
  getBackNews,
  getBackNewsSuccess,
  getTRPCRecommand,
  getInterestRecommend,
}